export const SET_CLINICIAN_DATA = 'setClinicianData'
export const SET_INDIVIDUAL_CLINICIAN_DATA = 'setIndividualClinicianData'
export const SET_CLINICIAN_ERROR = 'setCliniciansError'
export const SET_PATIENT_DATA = 'setPatientData'
export const SET_INDIVIDUAL_PATIENT_DATA = 'setIndividualPatientData'
export const SET_PATIENT_ERROR = 'setCliniciansError'
export const SET_OPEN_PATIENT_DATA = 'setOpenPatientData'
export const SET_OPEN_PATIENT_ERROR = 'setOpenPatientDataError'
export const SET_OPEN_PATIENT_VIDEOS_DATA = 'setOpenPatientVideosData'
export const SET_USER_DATA = 'setUserData'
export const SET_INDIVIDUAL_USER_DATA = 'setIndividualUserData'
export const SET_USER_ERROR = 'setUserError'
export const SET_AUTH = "setAuth"
export const SET_AUTH_ROLES_DATA = "setAuthRolesData"
export const SET_AUTH_ERROR = 'setAuthError'
export const SET_PROCEDURE_DATA = 'setProcedureData'
export const SET_INDIVIDUAL_PROCEDURE_DATA = 'setIndividualProcedureData'
export const SET_PROCEDURE_ERROR = 'setProcedureError'
export const SET_SURVEYS_DATA = 'setSurveysData'
export const SET_INDIVIDUAL_SURVEY_DATA = 'setIndividualSurveyData'
export const SET_SURVEY_ERROR = 'setSurveyError'
export const SET_EDUCATIONS_DATA = 'setEducationsData'
export const SET_INDIVIDUAL_EDUCATION_DATA = 'setIndividualEducationData'
export const SET_EDUCATION_ERROR = 'setEducationError'
export const SET_ROLE_DATA = 'setRoleData'
export const SET_ROLE_ERROR = 'setRoleError'
export const SET_ORGANIZATION_DATA = 'setOrganizationData'
export const SET_ORGANIZATION_ERROR = 'setOrganizationError'
export const SET_ORGANIZATION_NAME_DATA = 'setOrganizationNameData'
export const SET_UPDATE_USER_PASSWORD_DATA = 'setUpdateUserPasswordData'
export const SET_TIMEOUT_ERROR = 'setTimeOutError'
export const SET_FITBIT_DATA = 'setFitbitData'
export const SET_FITBIT_ERROR = 'setFitbitError'
export const SET_AGREEMENT_DATA = 'setAgreementData'
export const SET_AGREEMENT_ERROR = 'setAgreementError'
export const STATE_RESET = 'statereset'
export const STATE_AUTH_RESET = 'stateAuthReset'
export const SET_IS_LOADING = 'setIsLoading'
export const SET_TOAST = 'setToast'
export const GLOBAL_STATE_RESET = 'globalStateReset'
export const SET_KIOSK_MODE_STATUS = 'setKioskModeStatus'
export const SET_USERNAME = 'setUsername'
export const SET_TIME_TRACKING_DATA = 'setTimeTrackingData'
export const SET_TIME_TRACKING_ERROR = 'setTimeTrackingError'
export const SET_AVAILABLE_ORGANISATION = 'setAvailableOrganisation'
export const SET_LOGIN_USER_DETAILS = 'setLoginUserDetails'
export const SET_DEVICE_DATA = 'setDeviceData'
export const SET_DEVICE_ERROR = 'setDeviceError'
export const SET_FHIR_ORG_FOR_CLIENT_DATA = 'setFhirOrgForClientData'
export const SET_FHIR_REG_ORG_DATA = 'setFhirRegOrgData'
export const SET_FHIR_PHYSICIAN_MAPPING_DATA = 'setFhirPhysicianMappingData'
export const SET_FHIR_PATIENT_MAPPING_DATA = 'setFhirPatientMappingData'
export const SET_FHIR_SEARCH_PHYSICIAN_DATA = 'setFhirSearchPhysicianData'
export const SET_FHIR_SEARCH_PATIENT_DATA = 'setFhirSearchPatientData'
export const SET_FHIR_ERROR = 'setFhirError'
export const SET_ADMIN_DEVICES_DATA = 'setAdminDevicesData'
export const SET_ADMIN_DEVICES_ERROR = 'setAdminDevicesError'
export const SET_ORGANIZATION_FEATURES = 'setOrgaizationFeatures'
export const SET_CHARTS_DATA = 'setChartsData'
export const SET_COMPLIANCE_DATA = 'setComplianceData'
export const SET_COMPLIANCE_ERROR = 'setComplianceError'
export const SET_COMPLIANCE_REPORTS_DATA = 'setComplianceReportsData'
export const SET_COMPLIANCE_REPORTS_ERROR = 'setComplianceReportsError'
export const SET_CARE_PLAN = 'setCarePlan'
export const SET_PROCEDURE_CATEGORY = 'setProcedureCategory'
export const SET_APPOINTMENT_DATA = 'setAppointmentData'
export const SET_APPOINTMENT_ERROR = 'setAppointmentError'
export const SET_RECENT_APPOINTMENT_DATA = 'setRecentAppointmentData'
export const SET_RECENT_APPOINTMENT_ERROR = 'setRecentAppointmentError'
export const SET_CLINICIAN_PATIENT_DATA = 'setClinicianPatientData'
export const SET_PATIENT_ALERTS_HISTORY_DATA = 'setPatientAlertsHistoryData'
